<div class="flex items-center  w-full">
  
  <div 
    #container
    class="flex flex-wrap overflow-hidden transition-[max-height] duration-300"
    [style.max-height]="isExpanded() ? '1000px' : '1.76rem'" 
  >      
  <div class="mr-2 mb-1">
    <spike-etiquette 
      [label]="noLabelName()" 
      [severity]="getSeverity(null)" 
      (click)="onClick($event, null)">
    </spike-etiquette>
</div>
    @for (etiquette of etiquetteList(); track etiquette.etiquetteId) {
        <div class="mr-2">

      <spike-etiquette 
        [etiquette]="etiquette" 
        [severity]="getSeverity(etiquette.etiquetteId!)" 
        (click)="onClick($event, etiquette.etiquetteId!)">
      </spike-etiquette>
        </div>
    }
  </div>

  @if(hasOverflow() || isExpanded()) {
    <p-button 
      [icon]="isExpanded() ? 'pi pi-chevron-up' : 'pi pi-ellipsis-h'"
      (click)="isExpanded.set(!isExpanded())"
      class="p-button-rounded p-button-text p-button-sm flex-shrink-0" link 
      size="small"
      >
    </p-button>
  }
</div>